import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css'; // Import the custom CSS
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome
import logo from '../images/Gemini_Generated_Image_vbkhb3vbkhb3vbkh.jpg'; // Import the logo image

import fluidsImage from '../assets/fluids.jpg';
import printerImage from '../assets/Printer.jpg';
import sparepartsImage from '../assets/Spareparts.jpg';
import machineImage from '../assets/Machine.jpg';

const categories = [
  { image: fluidsImage, name: 'Fluids' },
  { image: printerImage, name: 'Printer' },
  { image: sparepartsImage, name: 'Spareparts' },
  { image: machineImage, name: 'Machine' }
];

function Navbar() {
  const user = JSON.parse(localStorage.getItem('users'));
  const navigate = useNavigate();

  // Logout function
  const logout = () => {
    localStorage.removeItem('users');
    navigate("/login");
  };

  // Collapse the navbar when clicking outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      const navbarCollapse = document.getElementById('navbarSupportedContent');
      const isNavbarOpen = navbarCollapse.classList.contains('show');
      
      if (isNavbarOpen && !navbarCollapse.contains(event.target)) {
        const navbarToggler = document.querySelector('.navbar-toggler');
        if (navbarToggler) {
          navbarToggler.click();
        }
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  // Close the navbar after clicking on a link
  const handleNavLinkClick = () => {
    const navbarCollapse = document.getElementById('navbarSupportedContent');
    if (navbarCollapse.classList.contains('show')) {
      const navbarToggler = document.querySelector('.navbar-toggler');
      navbarToggler.click();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg" style={{ backgroundColor: '#007bff', height: 65 }}>
      <div className="container-fluid d-flex justify-content-between">
        <Link className="navbar-brand d-flex align-items-center" to="/" style={{ color: 'white' }}>
          <img src={logo} alt="Brand Logo" style={{ height: '40px', marginRight: '10px' }} />
          A.A Smart Jet Technology
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={() => {
            document.querySelector('.navbar-toggler').classList.toggle('collapsed');
          }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 d-flex justify-content-end gap-responsive">
            <li className="nav-item">
              <Link to="/" className="nav-link active" aria-current="page" style={{ color: 'white' }} onClick={handleNavLinkClick}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/allproduct" className="nav-link active" aria-current="page" style={{ color: 'white' }} onClick={handleNavLinkClick}>
                All-Products
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about" style={{ color: 'white' }} onClick={handleNavLinkClick}>
                About Us
              </Link>
            </li>
            <li className="nav-item dropdown">
  <Link
    className="nav-link dropdown-toggle"
    to="#"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    style={{ color: 'white' }}
  >
    Products
  </Link>
  <ul className="dropdown-menu" style={{ backgroundColor: '#007bff' }}>
    {categories.map((item, index) => (
      <li key={index}>
        <Link
          className="dropdown-item d-flex align-items-center"
          to={`/category/${item.name.toLowerCase()}`}
          style={{ color: 'white' }}
          onClick={(e) => {
            e.stopPropagation(); // Prevent dropdown menu from closing
            handleNavLinkClick(); // Collapse navbar after a selection
          }}
        >
          <img
            src={item.image}
            alt={item.name}
            style={{ width: '30px', height: '30px', marginRight: '10px' }}
          />
          {item.name}
        </Link>
      </li>
    ))}
  </ul>
</li>

            <li className="nav-item">
              <Link className="nav-link" to="/services" style={{ color: 'white' }} onClick={handleNavLinkClick}>
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact" style={{ color: 'white' }} onClick={handleNavLinkClick}>
                Contact Us
              </Link>
            </li>
            {!user ? (
              <li className="nav-item d-none">
                <Link className="nav-link" to="/login" style={{ color: 'white' }} onClick={handleNavLinkClick}>
                  Login
                </Link>
              </li>
            ) : (
              <>
                {user?.role === "admin" && (
                  <li className="nav-item">
                    <Link className="nav-link" to="/admin-dashboard" style={{ color: 'white' }} onClick={handleNavLinkClick}>
                      Admin
                    </Link>
                  </li>
                )}
                <li className="nav-item">
                  <button className="nav-link btn btn-link" onClick={logout} style={{ color: 'white' }}>
                    Logout
                  </button>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
